const MAX_HOURS = 23;
const MAX_MINUTES = 59;
const MAX_SECONDS = 59;
const DEFAULT_TIME = { hours: '00', minutes: '00', seconds: '00' };
const DEFAULT_TIME_WITHOUT_HOURS = { minutes: '00', seconds: '00' };

export {
    MAX_HOURS,
    MAX_MINUTES,
    MAX_SECONDS,
    DEFAULT_TIME,
    DEFAULT_TIME_WITHOUT_HOURS
}